import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormContext } from "../../utils/FormContext.jsx";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../utils/AuthContext/AuthContext.jsx";
import CompletedSVG from "../../assets/Completed.jsx";
import SignatureSVG from "../../assets/Signature.jsx";
import config from '../../utils/config.js'


// Actions Redux
import { addPacketDetails } from "../../redux/actions.js";


const PacketComplete = () => {
  const dispatch = useDispatch();
    
  const [etchPacketEid, setEtchPacketEid] = useState('');
  const [formId, setFormId] = useState('');
  const { token } = useAuth();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  
  const packetDetails = useSelector((state) => state.packet.packetDetails[etchPacketEid]);

  useEffect(() => {
    const formIdFromUrl = new URLSearchParams(window.location.search).get('formId');
    if (formIdFromUrl) {
      setFormId(formIdFromUrl);
    }
  }, []);

  const navigateToHome = () => {
    navigate(`/`);
};

  useEffect(() => {
    if (!etchPacketEid) {
      return;
    }
  
    const fetchData = async () => {
      setIsLoading(true);
      try {
        // const response = await fetch(`http://localhost:5000/api/packet/${etchPacketEid}`);
        const response = await fetch(`${config.apiBaseUrl}/packet/${etchPacketEid}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        // console.log("Data Inside Effect:", data);
        // Update the dispatch to match the new action structure
        dispatch(addPacketDetails(etchPacketEid, { etchPacket: data.data.etchPacket }));

    // After fetching packet details, update the form data with the etchPacketEid
    // const putResponse = await fetch(`http://localhost:5000/api/formdata/${formId}`, {
      const putResponse = await fetch(`${config.apiBaseUrl}/formdata/${formId}`, {
      method: 'PUT',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
          etchPacketEid: data.data.etchPacket.eid,
          packetDetails: data.data.etchPacket,
      }),
    });

    if (!putResponse.ok) {
      throw new Error(`HTTP error! status: ${putResponse.status}`);
    }

    const putData = await putResponse.json();
    // console.log('Success:', putData);
  } catch (e) {
    setError(e.toString());
  } finally {
    setIsLoading(false);
  }
};
    fetchData();
  }, [etchPacketEid, dispatch]);

  useEffect(() => {
    const etchPacketEidFromUrl = new URLSearchParams(window.location.search).get('etchPacketEid');
    const formIdFromUrl = new URLSearchParams(window.location.search).get('formId');
    if (etchPacketEidFromUrl) {
      setEtchPacketEid(etchPacketEidFromUrl);
    }
    if (formIdFromUrl) {
      setFormId(formIdFromUrl);
    }
  }, []);

  useEffect(() => {
    // Safely access the deeply nested downloadURL
    const downloadURL = packetDetails?.etchPacket?.documentGroup?.files?.[0]?.downloadURL;
  
    if (downloadURL) {
      // Logic here will run when downloadURL changes and is not undefined/null
      // console.log("Download URL has changed:", downloadURL);
      // Any other logic you need to run when downloadURL changes
    }
  }, [packetDetails?.etchPacket?.documentGroup?.files?.[0]?.downloadURL]); // Dependency array tracking changes to downloadURL

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

      let status, statusClasses, remainingSigners;

      if (packetDetails && packetDetails.etchPacket) {
        status = packetDetails.etchPacket.status;
        remainingSigners = packetDetails.etchPacket.numberRemainingSigners;
    
        if (status === 'completed') {
            statusClasses = "bg-green-100 text-green-600 rounded-xl text-center p-1";
        } else {
            statusClasses = "bg-blue-100 text-blue-700 rounded-xl text-center p-1";
        }
    }

    // console.log("PacketDetails outside of useEffect:", packetDetails);

    if (packetDetails && packetDetails.etchPacket && packetDetails.etchPacket.documentGroup && packetDetails.etchPacket.documentGroup.signers) {
      const lastCompletedRoutingOrder = packetDetails.etchPacket.documentGroup.signers.reduce((maxOrder, signer) => {
        return signer.status === 'completed' ? Math.max(maxOrder, signer.routingOrder) : maxOrder;
      }, 0);

      const newSigners = packetDetails.etchPacket.documentGroup.signers.map((signer, index) => {
        let statusText;
        if (signer.status === 'completed') {
          statusText = 'Signed';
        } else if (signer.routingOrder === lastCompletedRoutingOrder + 1) {
          statusText = 'Awaiting Signature';
        } else {
          statusText = 'Awaiting Email After Signer Above Signs';
        }
        return { ...signer, statusText }; // return the signer object with the statusText
      })
    
      let newPacketDetails = {
        ...packetDetails,
        etchPacket: {
          ...packetDetails.etchPacket,
          documentGroup: {
            ...packetDetails.etchPacket.documentGroup,
            signers: newSigners
          }
        }
      }
    }
    
  if (packetDetails && packetDetails.etchPacket) {
      return (          
        <div className="w-[330px] md:w-[750px] flex justify-start items-center max-h-[825px]">
          <div className="w-[330px] md:w-[750px] p-2 md:p-6 mt-3 bg-white rounded-lg shadow-[rgba(0,0,0,.5)_-2px_2px_10px_-5px] flex-col gap-8 flex">
            <div className="gap-5 p-5 w-full">
            {
              packetDetails && packetDetails.etchPacket && packetDetails.etchPacket.documentGroup && (
                <> 
                   <h1 className="text-shi-green font-semibold w-full mb-6 h-auto text-lg md:text-3xl">
                    Congratulations {packetDetails.etchPacket.documentGroup.signers[0].name}, you have signed!
                  </h1>
                  {packetDetails.etchPacket.documentGroup.signers.length > 1 && (
                   <span className="text-slate-700 font-light w-full font-[Inter] h-auto text-[14px] md:text-lg mb-5">
                    An email has been sent to {packetDetails?.etchPacket?.documentGroup?.signers[1]?.name}                     
                  </span> 
                  )}
                  <div className="flex flex-col w-full gap-2">
                  <p className=" w-full text-[14px] md:text-lg mt-6"><strong>What to Expect Next:</strong></p>
                  <ol className="list-number list-inside">1. This contract will be completed once ALL buyers and sellers have signed.</ol>
                  <ol className="list-number list-inside">2. If accepted you as the buyer are reponsible for certain dates and deadlines that you set in the contract</ol>
                  <ol className="list-number list-inside">3. If accepted you are responsible for sending the earnest money by the date specified in the contract.</ol>
                  </div>
                </>
              )
            }
            </div>
          {packetDetails && packetDetails.etchPacket && (
            <div className="gap-5 p-5 w-[330px] md:w-[650px]">
                {/* <p className="m-2"><strong>Contract Name:</strong> {packetDetails.etchPacket.name}</p>
                  <p className="m-2">
                    <strong>Status:</strong> <div className={`w-auto p-1 px-2 inline-flex items-center text-sm font-[Inter] justify-center ${statusClasses}`}>{status === "completed" ? "Completed" : "In Progress"}</div>
                  </p> */}
                {/* <p className="m-2 pb-5"><strong>Number Remaining Signers:</strong> {packetDetails.etchPacket.numberRemainingSigners}</p> */}
                {
                  packetDetails && packetDetails.etchPacket && packetDetails.etchPacket.documentGroup && packetDetails.etchPacket.documentGroup.signers && packetDetails.etchPacket.documentGroup.signers.map((signer, index) => {
                    return (
                      <div key={index} className="inline-flex mb-2 w-full">
                        <div className="inline-flex gap-2 items-center">
                          {signer.status === 'completed' && <CompletedSVG fill={'#4CAF50'} width={25} height={25}/>}
                          {signer.status === 'sent' && <SignatureSVG />}
                          <h1 className="pl-2 pr-2 font-bold">{signer.name}</h1>
                          <span>{signer.email}</span>
                          <span>
                            {signer.statusText} 
                          </span>
                        </div>
                      </div>
                    );
                  })
                }
                <div className="flex flex-col justify-center items-center w-[250px] md:w-[650px] m-5 gap-5">
                  {/* {packetDetails?.etchPacket?.documentGroup?.files?.[0]?.downloadURL && (
                    <button 
                      className="w-[170px] md:w-[200px] justify-center text-center text-white bg-shi-green text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-green-950 items-center flex"
                    >
                      <a href={packetDetails.etchPacket.documentGroup.files[0].downloadURL}>Download Contract</a>
                    </button>
                  )} */}
                    <button 
                      className="w-[170px] md:w-[200px] justify-center text-center text-shi-green bg-slate-200 text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-slate-400 items-center flex"
                      onClick={navigateToHome}
                      >
                      Return Home</button>
                </div>
            </div>
            )}
          </div>
        </div>
      );
      }; 
    };

export default PacketComplete;